module.exports = __webpack_public_path__ + "img/no-image.74813459.png";